import React from 'react';
import {Sprite} from '@inlet/react-pixi';
import {Texture} from 'pixi.js';

type PayContainerAlignerProps = {
    visible: boolean;
    width: number;
};

export function PayContainerAligner({visible, width}: PayContainerAlignerProps): JSX.Element {
    return (
        <Sprite
            visible={visible}
            width={width}
            texture={Texture.EMPTY}
        />
    );
}